// extracted by mini-css-extract-plugin
export default {"mainAvisos":"MainAvisos_mainAvisos__Q-JWC","aparecendo":"MainAvisos_aparecendo__sXXcx","icon":"MainAvisos_icon__BV-JL"};